module.exports = __webpack_public_path__ + "img/the-awards-logo.49776661.png";